// theme.js or theme.ts

import { createTheme } from "@mui/material/styles";

// Define your custom colors here
const customColors = {
  gold: "#ebc47f",
  shinyGold: "#FFD54F",
  lightGold: "#f5e3c6",
  darkGold: "#e3ad4f",
  grayedGold: "#94805d",
  silver: "#c3c3c3",
  textAccent: "#000",
  background: "#fff",
  paperBackground: "#FAFAFA",
  semiDarkGray: "#333",
  mediumGray: "#3e4347",
  gray: "#596171",
  lightGray: "#474b4c",
  lighterGray: "#F5F5F5",
  green: "#00b67a",
  fieldBackground: "#2d2d2d",
  fieldBackgroundLight: "#3b3b3b",
  fieldBorder: "#777777",
  fieldBorderLight: "#b3b3b3",
  darkGray: "#282828",
  white: "#fff",
  headerBackground: "#000",
  headerText: "#fff",
  iconTitleColor: "#00b67a",
  authButtons: "#fff",
};

const planColors = {
  basic: "#FFDE21",
  standard: "#FE6900",
  professional: "#00b67a",
  enterprise: "#0E4C92",
};

const gradientBackgroundImage = `linear-gradient(130deg, ${customColors.background}, ${customColors.mediumGray})`;
const goldGradient =
  "linear-gradient(135deg, #ebc47f 0%, #e8c890 50%, #d3a65a 100%)";

const blueGradient =
  "linear-gradient(90deg,rgba(4, 19, 41, 1) 0%, rgba(64, 106, 143, 1) 50%, rgba(0, 34, 48, 1) 100%)";

const greenGradient =
  "linear-gradient(90deg,rgba(0, 150, 100, 1) 0%, rgba(54, 217, 163, 1) 50%, rgba(0, 150, 100, 1) 100%)";
const goldGradientCentral =
  "radial-gradient(circle at top center, " +
  "#e8c890" +
  ", " +
  customColors.gold +
  ")";
const darkGradient =
  "linear-gradient(135deg, #2e2f30 0%, #4f4f4f 50%, #282828 100%)";
const goldShadow = (opacity: string) =>
  "0 0px 15px 6px rgba(235, 196, 127, )" + opacity + ")";
// Create a theme using Material-UI's `createTheme`
const theme = createTheme({
  palette: {
    primary: {
      main: customColors.gold,
    },
    secondary: {
      main: customColors.silver,
    },
    text: {
      primary: customColors.textAccent,
    },
  },
  // You can also define other aspects like typography, spacing, etc.
  //   components: {
  //     MuiButton: {
  //       styleOverrides: {
  //         root: {
  //           borderRadius: '8px', // Example override for button styles
  //         },
  //       },
  //     },
  //   },
});

export {
  theme,
  customColors,
  gradientBackgroundImage,
  goldGradient,
  goldGradientCentral,
  goldShadow,
  blueGradient,
  darkGradient,
  planColors,
  greenGradient,
};
